import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@modules/auth';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if ([401, 403].indexOf(err.status) !== -1 && err.error && err.error.message !== 'SUBSCRIPTION_INACTIVE') {
          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          this.logout();
        }

        // Always return the error as an observable
        return throwError(err);
      })
    );
  }

  private logout(): void {
    // Lazy injection to avoid circular dependency
    const authService: AuthService = this.injector.get(AuthService);

    if (authService && authService.logout) {
      // Use AuthService logout method to properly clear user state
      authService.logout();
    }
  }
}
